import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { COLLECTIONS } from "@/data/products";
import ProductCard from "@/components/ProductCard";
import FamilyFilter, { useFamilyFilter } from "@/components/FamilyFilter";
import { useMedia } from "@/context/MediaContext";
import { useProducts } from "@/context/ProductsContext";
import Seo from "@/components/Seo";

export default function Collections() {
  const img = useMedia();
  const { products } = useProducts();
  const ff = useFamilyFilter(products);
  return (
    <main data-testid="collections-page" className="pt-24 md:pt-32">
      <Seo
        title="Collections — Reserve 30 Parfums"
        description="Explore the full Reserve 30 line: Rouge Éclipse, Imperial Ash, Ember Rush, Crimson Spice and Velvet Rouge. Parfum-strength luxury fragrances from ₹499."
      />
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 pb-24">
        <Reveal>
          <p className="overline-label">The Collections</p>
          <h1 className="font-serif-brand text-5xl sm:text-6xl lg:text-7xl font-light mt-4 leading-[0.95]">
            Every scent,<br />a statement.
          </h1>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {Object.entries(COLLECTIONS).map(([slug, c], i) => (
            <Reveal key={slug} delay={i * 0.1}>
              <Link to={`/collections/${slug}`} data-testid={`collections-page-card-${slug}`} className="group block relative overflow-hidden">
                <div className="aspect-[3/4] overflow-hidden bg-[#111]">
                  <img
                    src={img(`collection_${slug.replace("-", "_")}`, c.image)}
                    alt={c.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-0 p-6 text-[#F7F3EE]">
                  <p className="text-[0.65rem] uppercase tracking-[0.28em] text-[#BA8D53] mb-1">{c.tagline}</p>
                  <h2 className="font-serif-brand text-3xl font-light">{c.title}</h2>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-28 mb-10">
          <p className="overline-label">All Fragrances</p>
          <h2 className="font-serif-brand text-4xl md:text-5xl font-light mt-4">The Full Line</h2>
        </Reveal>
        <FamilyFilter {...ff} total={products.length} shown={ff.filtered.length} />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {ff.filtered.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 4) * 0.08}>
              <ProductCard p={p} />
            </Reveal>
          ))}
        </div>
        {ff.filtered.length === 0 && <p className="text-black/50" data-testid="family-filter-empty">No fragrance matches that family yet.</p>}
      </div>
    </main>
  );
}
